'use client';
const getTruncate = (truncate)=>{
    if (truncate === 'start') {
        return {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            direction: 'rtl',
            textAlign: 'right'
        };
    }
    return {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    };
};

export { getTruncate };
//# sourceMappingURL=getTruncate.js.map
